import React from 'react';


import MyCard from './MyCard.js';
import Exercices from './exercices/Exercices.js';
import Cours from './cours/Cours.js';
import Click from './Click.js';

import Alert from 'react-bootstrap/Alert';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


class Content extends React.Component{
  render(){
    return(
            <div className="mt-3">
                
                <Click />
            </div>
    );
  }
}

export default Content;
